var _CustomRadio;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { shouldForwardProp } from '../../utils';
import { screenReaderOnly } from '../Mixins/Mixins';
import { radioDiameter, transitionConfig, createSelector } from '../Form/SharedBaseComponents';
var CustomRadio = styled.span.withConfig({
  displayName: "Radio__CustomRadio",
  componentId: "sc-jdbc45-0"
})(["display:inline-block;width:", "px;height:", "px;flex:0 0 ", "px;box-sizing:border-box;border:2px solid ", ";border-radius:100px;background-color:transparent;position:relative;box-shadow:0 0 0 0 rgba(0,0,0,0.1);transition:box-shadow ", ";&::after{content:'';position:absolute;width:", "px;height:", "px;top:50%;left:50%;transform-origin:50% 50%;transform:translateX(-50%) translateY(-50%) scale(0);border-radius:100px;background-color:", ";transition:all 0.1s;}"], radioDiameter, radioDiameter, radioDiameter, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.iconPlaceholder;
}, transitionConfig, radioDiameter * 0.5, radioDiameter * 0.5, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.iconSelected;
});
var StyledInput = styled.input.withConfig({
  shouldForwardProp: shouldForwardProp
}).attrs({
  type: 'radio'
}).withConfig({
  displayName: "Radio__StyledInput",
  componentId: "sc-jdbc45-1"
})(["", " &:checked + span{border-color:", ";&::after{transition:all ", ";transform:translateX(-50%) translateY(-50%) scale(1);}}&:focus + span{box-shadow:", ";}&:disabled + span{opacity:0.4;}"], screenReaderOnly, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.iconSelected;
}, transitionConfig, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.input;
});
export var RadioInput = function RadioInput(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledInput, props), _CustomRadio || (_CustomRadio = /*#__PURE__*/React.createElement(CustomRadio, null)));
};
var RadioComponent = createSelector(RadioInput); // react styleguidist workaround

var Radio = function Radio(props) {
  return /*#__PURE__*/React.createElement(RadioComponent, props);
};

Radio.propTypes = {
  /** Provide a label (string or React node) as a child to the Radio component */
  children: PropTypes.node.isRequired,

  /** Visually hide the label */
  hideLabel: PropTypes.bool,
  disabled: PropTypes.bool
};
/** @component */

export default Radio;